var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGuard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.281 12.163c-2.048 0-3.691-1.793-3.691-4.034 0-2.18 1.661-3.946 3.691-3.946 2.04 0 3.692 1.749 3.692 3.937 0 2.25-1.644 4.043-3.692 4.043Zm0-1.028c1.442 0 2.61-1.319 2.61-3.015 0-1.635-1.177-2.91-2.61-2.91-1.432 0-2.601 1.293-2.601 2.919 0 1.696 1.169 3.006 2.601 3.006Zm-5.677 9.088c-1.292 0-1.908-.413-1.908-1.301 0-2.285 2.883-5.555 7.577-5.555 1.573 0 2.935.387 4.042.976a2.11 2.11 0 0 0-.896.72c-.87-.404-1.925-.668-3.146-.668-4.131 0-6.487 2.752-6.487 4.421 0 .273.14.378.536.378h8.27v.37c0 .246.018.456.053.659H6.604Zm9.008-.607v-3.173c0-.51.176-.8.686-1.002.615-.246 1.96-.72 2.522-.931.29-.114.59-.106.844-.018.589.22 1.942.703 2.566.95.501.202.677.492.677 1.001v3.173c0 1.573-.887 2.145-3.27 3.533a.793.793 0 0 1-.755 0c-2.382-1.38-3.27-1.96-3.27-3.533Zm3.13 1.538c.166 0 .307-.079.395-.193l2.496-3.454a.558.558 0 0 0 .105-.29.478.478 0 0 0-.474-.475.49.49 0 0 0-.405.211l-2.144 2.962-1.099-1.178a.467.467 0 0 0-.369-.175.462.462 0 0 0-.474.474c0 .114.035.246.122.352l1.46 1.59a.544.544 0 0 0 .386.176Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuard);
export default __webpack_public_path__ + "static/media/Guard.a7f0302e8aacae6d207797c040d94036.svg";
export { ForwardRef as ReactComponent };